import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../components/common/Footer';
import PinVerification from '../components/gallery/PinVerification';
import GalleryView from '../components/gallery/GalleryView';
import { getRegistrationDetails } from '../services/api';
import { isAuthenticated, getUuid, logout } from '../services/auth';

const AIDelivery = () => {
    const { uuid } = useParams();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    if(uuid !== getUuid()){
        logout();
    }
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setLoading(true);
                const response = await getRegistrationDetails(uuid);

                if (response.result) {
                    setUserData({
                        name: response.data.name,
                        registrationId: uuid,
                        event: response.data.event || {}
                    });
                    setIsVerified(isAuthenticated());
                } else {
                    setError('Registration not found');
                }
            } catch (err) {
                console.log(err)
                setError('Failed to load registration data');
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [uuid]);

    const handlePinSuccess = () => setIsVerified(true);

    if (loading) return <div className="pageloader"><div className="spinner"></div><p>Loading...</p></div>;

    if (error || !userData) {
        return (
            <>
                <div className="container">
                    <div className="error-content mt-4">
                        <p>{error || 'Registration not found'}</p>
                        <button className="button" onClick={() => window.location.reload()}>Try Again</button>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <div className="ai-delivery-page">
            <div className="hero" style={{
                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #4CAF50 100%)'
            }}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-title">{userData.event.title || 'Your Photos'}</h1>
                    <p className="hero-subtitle">
                        {isVerified ? 'AI-Powered Photo Delivery' : 'Please verify to access your photos'}
                    </p>
                </div>
            </div>

            <div className="container">
                <div className="card mt-4">
                    {!isVerified ? (
                        <PinVerification
                            uuid={uuid}
                            userName={userData.name}
                            onSuccess={handlePinSuccess}
                        />
                    ) : (
                        <GalleryView
                            uuid={uuid}
                            eventDetails={userData.event}
                            lazyLoad={true}
                        />
                    )}
                </div>
            </div>
            <Footer business={userData?.event?.business} />
        </div>
    );
};

export default AIDelivery;
